var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Close",
    width: 24,
    height: 24,
    "data-name": "Icon - Close",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Close_Popup",
    "data-name": "Icon - Close Popup",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h16v16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Close_Popup-2",
    "data-name": "Icon - Close Popup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Exclusion_8",
    fill: "#afafaf",
    d: "M19378 23274a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm0-6.588l2.121 2.117a1 1 0 1 0 1.414-1.412l-2.121-2.121 2.121-2.119a1.01 1.01 0 0 0 0-1.42.98.98 0 0 0-.7-.289.991.991 0 0 0-.711.295l-2.121 2.119-2.119-2.125a1 1 0 0 0-1.707.711.988.988 0 0 0 .293.7l2.121 2.125-2.121 2.121a1 1 0 0 0 0 1.412.977.977 0 0 0 .705.293.992.992 0 0 0 .709-.293l2.119-2.117z",
    "data-name": "Exclusion 8",
    transform: "translate(-19370 -23258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.f23d46d6b4d972c4969744d46606e818.svg";
export { ForwardRef as ReactComponent };